import NavigationSliderSecondary from 'component/NavigationSliderSecondary'
import { NavigationSliderSecondaryProps } from 'component/NavigationSliderSecondary/NavigationSliderSecondary.types'
import useStyleMaps, { StyleMap } from 'site/Renderer/hooks/useStyleMap'
import { Container, StyledAreaLine } from './NavigationSlider.styles'

export type OptionProps = {
  value: string
  label?: string
  color?: string
  Adornment?: React.ReactNode
}

export type NavigationSliderProps = {
  title?: string
  options?: OptionProps[]
  onPrevClick: () => void
  onNextClick: () => void
  disabled?: boolean
  disabledArrow?: 'prev' | 'next'
  currentIndex: number
  justifyContent?: NavigationSliderSecondaryProps['justifyContent']
  styleMap?: StyleMap
}

const NavigationSlider = ({
  title,
  options = [],
  onPrevClick,
  onNextClick,
  disabled,
  currentIndex,
  disabledArrow,
  justifyContent,
  styleMap
}: NavigationSliderProps) => {
  const styles = useStyleMaps(styleMap)

  const option: OptionProps = { value: title ?? '', color: '#303032' }

  const renderOptions: OptionProps[] =
    options?.length > 0
      ? options
      : Array.from({ length: currentIndex + 1 }, () => option)

  const centerAreaElement = (
    <Container>
      <NavigationSliderSecondary
        options={renderOptions}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        currentIndex={currentIndex}
        disabled={disabled}
        disabledArrow={disabledArrow}
        justifyContent={justifyContent}
      />
    </Container>
  )

  return <StyledAreaLine style={styles} centerAreaElement={centerAreaElement} />
}

export default NavigationSlider
